import { render, staticRenderFns } from "./comp_dpc-Spacer.vue?vue&type=template&id=416356ee&scoped=true"
import script from "./comp_dpc-Spacer.vue?vue&type=script&lang=js"
export * from "./comp_dpc-Spacer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416356ee",
  null
  
)

export default component.exports